module.exports = __webpack_public_path__ + "media/images/landing/second/photo8-b986df35adc17de04bd8d7575d0a5a85.jpg";